(function() { window.GUID_02b52198_93cc_4197_b35d_fdc5c0f0ef5d = { getGuid: function() { return "02b52198-93cc-4197-b35d-fdc5c0f0ef5d"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class Snackbar {
            //public static Show(params: Snackbar.Params, autoHideDuration = 5000) {
            //    if (params.id.trim() != "") {
            //        CS.Lag("snackbar", 10, () => {
            //            const $previousSnackbar = $(".snackbar-container");
            //            if ($previousSnackbar.length > 0) {
            //                Snackbar.hide($previousSnackbar, () => {
            //                    Snackbar.show(params, autoHideDuration);
            //                });
            //            } else {
            //                Snackbar.show(params, autoHideDuration);
            //            }
            //        });
            //    }
            //}
            static Show(params, stack) {
                if (params != null) {
                    if (params.Id != null && params.Id.trim() != "") {
                        CS.Lag("snackbar", 10, () => {
                            const $previousSnackbar = $(".snackbar-container").last();
                            if (!stack && $previousSnackbar.length > 0) {
                                Snackbar.hide($previousSnackbar, params.ReloadOnClose, () => {
                                    Snackbar.show(params, stack);
                                });
                            }
                            else {
                                Snackbar.show(params, stack);
                            }
                        });
                    }
                }
            }
            static show(params, stack) {
                var _a, _b;
                let { AutoHideDuration: autoHideDuration } = params;
                //Jai commenté ceci parce qu'on doit pouvoir rien mettre comme temps pour quil reste ouvert indéfiniment
                //if (autoHideDuration == null)
                //    autoHideDuration = 3000;
                const $snackbar = $(Snackbar.createElement(params, stack));
                let lagId = "snackbar-auto-hide";
                if (stack) {
                    const id = (_b = (_a = crypto.randomUUID) === null || _a === void 0 ? void 0 : _a.call(crypto)) !== null && _b !== void 0 ? _b : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
                    lagId += `-${id}`;
                }
                $(".section-middle").last().append($snackbar);
                $snackbar.animate({ opacity: 1 }, 300, () => {
                    $snackbar.find(".snackbar").addClass("show");
                    if (autoHideDuration) {
                        CS.Lag(lagId, autoHideDuration, () => {
                            Snackbar.hide($snackbar, params.ReloadOnClose, () => { });
                        });
                    }
                });
                $snackbar.offon("click.snackbar", (e) => {
                    const $target = $(e.target);
                    //Aussi ben de fermer la snack peut importe ou tu click????
                    //if ($target.hasClass("snackbar__close-icon")) {
                    Snackbar.hide($snackbar, params.ReloadOnClose, () => {
                        //params.onClose.call(this);
                    });
                    //}
                });
            }
            static hide($snackbar, reloadOnHide, callback) {
                if ($snackbar.length > 0) {
                    $snackbar.animate({ opacity: 0 }, 300, () => {
                        Snackbar.unbindClickEvent($snackbar);
                        $snackbar.remove();
                        callback.call(this);
                        if (reloadOnHide) {
                            CS.Nav.Refresh();
                        }
                    });
                }
            }
            static createElement(params, stack) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                let { Id: id, Type: type, Alignment: alignment, Message: txt, Animation: animation } = params;
                //if (txt) {
                //    txt = txt
                //        .replace(/\/u003c/gi, "<")
                //        .replace(/\/u003e/gi, ">")
                //        .replace(/\/u0027/gi, "'")
                //        .replace(/\/u0022/gi, "'")
                //        .replace(/\/u0026/gi, "&");
                //}
                txt = this.decodeHtmlEntities(txt);
                let containerCssClass = "snackbar-container";
                let contentCssClass = "snackbar";
                let txtCssClass = "snackbar__txt";
                let closeIconCssClass = "snackbar__close-icon icon ic-cs-times";
                let containerMargin = "";
                switch (type) {
                    case CS.Enumeration.SnackbarType.Danger:
                        contentCssClass += " snackbar__danger";
                        break;
                    case CS.Enumeration.SnackbarType.Info:
                        contentCssClass += " snackbar__info";
                        break;
                    case CS.Enumeration.SnackbarType.Success:
                        contentCssClass += " snackbar__success";
                        break;
                    case CS.Enumeration.SnackbarType.Warning:
                        contentCssClass += " snackbar__warning";
                        break;
                    default:
                        break;
                }
                switch (alignment) {
                    case CS.Enumeration.SnackbarAlignment.TopCenter:
                        containerCssClass += " snackbar-container__top";
                        containerCssClass += " snackbar-container__center";
                        containerMargin = `style="margin-top: ${(_b = (_a = CS.DOM.$sectionTop) === null || _a === void 0 ? void 0 : _a.outerHeight()) !== null && _b !== void 0 ? _b : 0}px"`;
                        break;
                    //case Snackbar.Alignment.TopLeft:
                    //    containerCssClass += " snackbar__top";
                    //    containerCssClass += " snackbar__left";
                    //    break;
                    //case Snackbar.Alignment.TopRight:
                    //    containerCssClass += " snackbar__top";
                    //    containerCssClass += " snackbar__right";
                    //    break;
                    //case Snackbar.Alignment.MiddleCenter:
                    //    containerCssClass += " snackbar__middle";
                    //    containerCssClass += " snackbar__center";
                    //    break;
                    //case Snackbar.Alignment.MiddleLeft:
                    //    containerCssClass += " snackbar__middle";
                    //    containerCssClass += " snackbar__left";
                    //    break;
                    //case Snackbar.Alignment.MiddleRight:
                    //    containerCssClass += " snackbar__middle";
                    //    containerCssClass += " snackbar__right";
                    //    break;
                    case CS.Enumeration.SnackbarAlignment.BottomCenter:
                        containerCssClass += " snackbar-container__bottom";
                        containerCssClass += " snackbar-container__center";
                        containerMargin = `style="margin-bottom: ${(_d = (_c = CS.DOM.$sectionBottom) === null || _c === void 0 ? void 0 : _c.outerHeight()) !== null && _d !== void 0 ? _d : 0}px"`;
                        break;
                    case CS.Enumeration.SnackbarAlignment.BottomLeft:
                        containerCssClass += " snackbar-container__bottom";
                        containerCssClass += " snackbar-container__left";
                        containerMargin = `style="margin-bottom: ${(_f = (_e = CS.DOM.$sectionBottom) === null || _e === void 0 ? void 0 : _e.outerHeight()) !== null && _f !== void 0 ? _f : 0}px"`;
                        break;
                    case CS.Enumeration.SnackbarAlignment.BottomRight:
                        containerCssClass += " snackbar-container__bottom";
                        containerCssClass += " snackbar-container__right";
                        containerMargin = `style="margin-bottom: ${(_h = (_g = CS.DOM.$sectionBottom) === null || _g === void 0 ? void 0 : _g.outerHeight()) !== null && _h !== void 0 ? _h : 0}px"`;
                        break;
                    default:
                        containerCssClass += " snackbar-container__bottom";
                        containerCssClass += " snackbar-container__center";
                        containerMargin = `style="margin-bottom: ${(_k = (_j = CS.DOM.$sectionBottom) === null || _j === void 0 ? void 0 : _j.outerHeight()) !== null && _k !== void 0 ? _k : 0}px"`;
                        break;
                }
                switch (animation) {
                    case CS.Enumeration.SnackbarAnimation.SlideUp:
                        contentCssClass += " snackbar__slide-up";
                        break;
                    case CS.Enumeration.SnackbarAnimation.SlideDown:
                        contentCssClass += " snackbar__slide-down";
                        break;
                    // case Enumeration.SnackbarAnimation.Fade:
                    //     contentCssClass += " snackbar__fade";
                    //     break;
                    default:
                        contentCssClass += " snackbar__slide-up";
                        break;
                }
                return `<div id="${id}" class="${containerCssClass}" ${containerMargin}>
                        <div class="${contentCssClass}">
                            <div class="${txtCssClass}">${CS.Helper.decodeHTMLEntities(txt)}</div>
                            <div class="${closeIconCssClass}"></div>
                        </div>
                    </div>`;
            }
            static unbindClickEvent($snackbar) {
                $snackbar.off("click.snackbar");
            }
            static decodeHtmlEntities(str) {
                const txt = document.createElement('textarea');
                txt.innerHTML = str;
                return txt.value;
            }
        }
        Controls.Snackbar = Snackbar;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=snackbar.js.map
